var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "full_layout pay",
      attrs: { id: "pay" }
    },
    [
      _c("h3", { staticClass: "informationTitle" }, [
        _vm._v(_vm._s(_vm.$t("Pay")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "payBox" }, [
        _vm.orderInfo != null
          ? _c("div", { staticClass: "payDetail" }, [
              _c("p", [_vm._v(_vm._s(_vm.orderInfo.Title))]),
              _vm._v(" "),
              _vm.orderInfo.OrderPresale != 2
                ? _c("div", { staticClass: "OrderPrice" }, [
                    _vm._v(
                      _vm._s(_vm.$t("OrderTotal")) +
                        "：￥" +
                        _vm._s(_vm.orderInfo.OrderPrice.toLocaleString())
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderInfo.OrderPresale == 2
                ? _c("div", { staticClass: "OrderPrice" }, [
                    _vm._v(
                      _vm._s(_vm.$t("OrderTotal")) +
                        "：" +
                        _vm._s(_vm.orderInfo.RealPoints) +
                        _vm._s(_vm.$t("Points")) +
                        " +￥" +
                        _vm._s(_vm.orderInfo.OrderPrice.toLocaleString())
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.otherType
        ? _c("div", { staticClass: "payBox payOtherDetail" }, [
            _c("div", {
              staticClass: "goBack",
              on: {
                click: function($event) {
                  _vm.otherType = false
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "payOtherBox" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("verify.UploadPaymentReceipt")))]),
              _vm._v(" "),
              _c("div", { staticClass: "otherinfo_title" }, [
                _vm._v(_vm._s(_vm.$t("ChoosePaymentChannel")))
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "otherinfoList addressList" },
                _vm._l(_vm.otherInfo, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      class: [
                        item.account == _vm.otherPay.transferAccount ? "on" : ""
                      ],
                      on: {
                        click: function($event) {
                          return _vm.checkOtherPay(item)
                        }
                      }
                    },
                    [
                      _c("div", [
                        _c("div", [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.language != "ch"
                                  ? "Company Name"
                                  : _vm.$t("CompanyName")
                              ) + ":"
                            )
                          ]),
                          _c("span", [_vm._v(_vm._s(item.account))])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.language != "ch"
                                  ? "Bank Name"
                                  : _vm.$t("BankName")
                              ) + ":"
                            )
                          ]),
                          _c("span", [_vm._v(_vm._s(item.company))])
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.language != "ch"
                                  ? "Bank Account"
                                  : _vm.$t("BankAccount")
                              ) + ":"
                            )
                          ]),
                          _c("span", [_vm._v(_vm._s(item.method))])
                        ]),
                        _vm._v(" "),
                        item.code != "" && item.code
                          ? _c("div", [
                              _c("span", [_vm._v("Swift Code:")]),
                              _c("span", [_vm._v(_vm._s(item.code))])
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "payOtherFrom" },
                [
                  _c("el-input", {
                    staticClass: "info_ipt",
                    attrs: { placeholder: "$t('verify.transaction')" },
                    on: {
                      input: function($event) {
                        return _vm.otherPayInfo(_vm.otherPay)
                      }
                    },
                    model: {
                      value: _vm.otherPay.transferJournal,
                      callback: function($$v) {
                        _vm.$set(_vm.otherPay, "transferJournal", $$v)
                      },
                      expression: "otherPay.transferJournal"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "info_ipt" }, [
                    _vm._v(_vm._s(_vm.$t("UploadPaymentReceipt")))
                  ]),
                  _vm._v(" "),
                  !_vm.otherPay.imgUrl
                    ? _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "uploadImgBox",
                          attrs: {
                            action: "",
                            "http-request": _vm.uploadImg,
                            "list-type": "picture",
                            "show-file-list": false,
                            limit: _vm.limit,
                            "on-exceed": _vm.handleExceed,
                            "before-upload": _vm.beforeUpload,
                            "on-success": _vm.uploadImgSuccess,
                            "on-error": _vm.uploadImgError,
                            "on-remove": _vm.handleRemove,
                            "with-credentials": true
                          }
                        },
                        [_c("span", { staticClass: "uploadImg" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.otherPay.imgUrl
                    ? _c("div", { staticClass: "uploadImgBox" }, [
                        _c(
                          "span",
                          { staticClass: "uploadImg" },
                          [
                            _c("i", {
                              staticClass: "delete",
                              on: {
                                click: function($event) {
                                  return _vm.deleteImg()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("el-image", {
                              attrs: {
                                src:
                                  _vm.otherPay.imgUrl + "?imageView2/2/w/120",
                                fit: "contain",
                                "preview-src-list": [_vm.otherPay.imgUrl]
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "info_btn",
                      attrs: { disabled: _vm.disabled, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.payOtherFrom(_vm.otherPay)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Submit")))]
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.otherType
        ? _c("div", { staticClass: "payBox" }, [
            _c("div", { staticClass: "pay-tab" }, [
              _c(
                "div",
                {
                  class: ["pay-type", _vm.PayChannel == 1 ? "on" : ""],
                  on: {
                    click: function($event) {
                      return _vm.changePay(1)
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("Alipay")) +
                      "、" +
                      _vm._s(_vm.$t("WeChatPay"))
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "payWebSocket" }, [
              _c("div", { staticClass: "payImg", class: _vm.imgClass }, [
                _c("canvas", {
                  staticStyle: { width: "200px", height: "200px" },
                  attrs: { id: "QRCode_header" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "payType" }, [
                _vm._v(_vm._s(_vm.$t("QRCodePayment")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "paybtn" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goToPage("/checkout/" + _vm.orderid)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("PaymentFailed")) + "？")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.goToPage("/order/detail/" + _vm.orderid)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("PaymentSuccessful")))]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.orderInfo && _vm.orderInfo.PayType != 3
              ? _c("div", { staticClass: "payOther" }, [
                  _vm._v(_vm._s(_vm.$t("verify.OtherPayment"))),
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          _vm.otherType = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("OtherPayment")))]
                  )
                ])
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9065d526", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9065d526","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pay/pay.vue
// module id = null
// module chunks = 